// Fonte única dos slugs reservados do admin.
//
// O primeiro segmento da URL é usado para detectar "slug de marca" (branding
// por path/subdomínio). Estes valores são as exceções — nunca tratados como
// parceiro. Consumido por: index.html (bloqueio pré-React), useBrand.ts
// (resolução de branding) e PartnerForm.tsx (validação de slug de parceiro).
//
// APP_ROUTE_SEGMENTS DEVE espelhar as rotas de primeiro nível em
// app/router/AppRouter.tsx — a trava scripts/check-reserved-slugs.ts valida isso
// no build e falha se algum segmento top-level não estiver aqui.

// Segmentos top-level de URL que o admin possui (rotas de primeiro nível).
export const APP_ROUTE_SEGMENTS = [
  'dashboard', 'users', 'chat', 'partners', 'providers', 'families',
  'team', 'care-coordination', 'content', 'settings', 'prontuario',
  'grants', 'companies', 'primeiros-passos',
] as const;

// Palavras de infra/framework que nunca podem ser um slug de parceiro.
// `painel` é a base do admin quando montado dentro do app unificado (A014).
export const INFRA_RESERVED = ['login', 'api', 'auth', 'health', 'public', 'assets', 'static', 'painel'] as const;

export const RESERVED_SLUGS: readonly string[] = [...APP_ROUTE_SEGMENTS, ...INFRA_RESERVED];
